import React from "react";
import InputField from '../../../components/inputs/inputField';
import ColorField from "../../../components/inputs/colorField";
import FileUploadInputBox from "../../../components/inputs/fileUploadInputBox";
import FilesUploaderModal from "../../../components/files/filesUploaderModal";

class CheckinSetup extends React.Component {
    constructor(props) {
        super(props);
		this.state = {
			uploadingAppIcon: "",
		};
    }
    
    

    render() {
		const appConfig = this.props.checkInAppConfiguration || {};
		const readOnly = this.props.readOnly || false;
		const requiredFields = this.props.requiredFields || {};

		return (
            <div className="sectionBody">
                <div className='blocksContainer'>
                    <div className='flex w-100'>
                        <div className="sectionBlock mr-25 contained-h">
                            <h2 className='blockHeader'>Application Details</h2>
                            <InputField
                                label="Name"
                                value={appConfig.name}
                                disabled={readOnly}
                                required={true}
                                errorTrigger={requiredFields.name}
								onChange={(e) => {
									this.props.handleChange({ name: e.target.value });
								}}
                            />
                            <InputField
								label="Short Name"
								value={appConfig.shortName}
								disabled={readOnly}
								required={true}
								errorTrigger={requiredFields.shortName}
								onChange={(e) => {
									this.props.handleChange({ shortName: e.target.value });
								}}
							/>

							<InputField
								label="Description"
								value={appConfig.description}
								disabled={readOnly}
								required={true}
								errorTrigger={requiredFields.description}
								onChange={(e) => {
									this.props.handleChange({ description: e.target.value });
								}}
							/>
                            
							<ColorField
								label="Background Color"
								value={appConfig.backgroundColor}
								type="color"
								useHex={true}
								disabled={readOnly}
								required={true}
								errorTrigger={requiredFields.backgroundColor}
								onChange={(e) => {
									this.props.handleChange({ backgroundColor: e });
								}}
							/>

							<ColorField
								label="Theme Color"
								value={appConfig.themeColor}
								type="color"
								useHex={true}
								disabled={readOnly}
								required={true}
								errorTrigger={requiredFields.themeColor}
								onChange={(e) => {
									this.props.handleChange({ themeColor: e });
								}}
							/>
                            <h2 className='blockHeader'>Color Options</h2>
                            <ColorField
								label="Brand Color"
								value={appConfig.brandColor}
								type="color"
								useHex={true}
								disabled={readOnly}
								required={true}
								errorTrigger={requiredFields.brandColor}
								onChange={(e) => {
									this.props.handleChange({ brandColor: e });
								}}
							/>

							<ColorField
								label="Button Text Color"
								value={appConfig.buttonTextColor}
								type="color"
								useHex={true}
								disabled={readOnly}
								required={true}
								errorTrigger={requiredFields.buttonTextColor}
								onChange={(e) => {
									this.props.handleChange({ buttonTextColor: e });
								}}
							/>
                            <h2 className='blockHeader'>Application Icons</h2>
							<div className="flex aic gap20">
								<FileUploadInputBox
									label="Small (128x128)"
									onClick={() => {
											this.setState({ uploadingAppIcon: "small" });
										}}
										value={appConfig.icons.small}
										clearFile={() => {
											this.props.handleChange({ icons: { ...appConfig.icons, small: "" } });
											this.setState({ uploadingAppIcon: "" });
										}}
									addText="Icon"
								/>
								<FileUploadInputBox
									label="Medium (256x256)"
									onClick={() => { this.setState({ uploadingAppIcon: "medium" }); }}
									value={appConfig.icons.medium}
									clearFile={() => {
										this.props.handleChange({ icons: { ...appConfig.icons, medium: "" } });
										this.setState({ uploadingAppIcon: "" });
									}}
									addText="Icon"
								/>
								<FileUploadInputBox
									label="Large (512x512)"
									onClick={() => { this.setState({ uploadingAppIcon: "large" }); }}
									value={appConfig.icons.large}
									clearFile={() => {
										this.props.handleChange({ icons: { ...appConfig.icons, large: "" } });
										this.setState({ uploadingAppIcon: "" });
									}}
									addText="Icon"
								/>
							</div>
							{this.state.uploadingAppIcon !== "" && <FilesUploaderModal
								title="Icon"
								isOpen={this.state.uploadingAppIcon !== ""}
								toggle={() => this.setState({ uploadingAppIcon: "" })}
								eventId={this.props.eventId}
								links={{
									getAssets: `Organizations/${this.props.orgId}/events/${this.props.eventId}/assets`,
									addAssets: `Organizations/${this.props.orgId}/events/${this.props.eventId}/assets`,
								}}
								orgId={this.props.orgId}
								addFiles={(fileURL) => {
									this.props.handleChange({ icons: { ...appConfig.icons, [this.state.uploadingAppIcon]: fileURL } });
									this.setState({ uploadingAppIcon: "" });
								}}
							/>}

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CheckinSetup;